import React, { Component } from "react";
import { View, StyleSheet, ScrollView, Platform } from "react-native";
import Text from "../components_v2/TextFont";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { translate } from "../locales/translate";
import ArTheme from "../argon-ui/Theme";
import { TouchableHighlight } from "react-native";
import FontAwesomeIcon from "../components_v2/FontAwesomeIcon";
import { faPlus } from "../../assets/consts/faCharCodes";
import { SimpleIcon } from "../components_v2/Buttons";
import Spinner from "../components_v2/Spinner";

import {
  faEdit,
  faPowerOff,
  FONT_FAMILIES,
} from "../../assets/consts/faCharCodes";
import { TouchableOpacity } from "react-native";
import * as AreaActions from "../actions/AreaActions";
import AlertDialogBase from "../nativeBase-ui/AlertDialog";
import * as DeviceTypes from "../components/devices/_deviceTypes";
import ModalBase from "../nativeBase-ui/ModalBase";
import { HStack } from "native-base";
import { ArButton } from "../argon-ui";
import Switch from "../components/ToggleSwitch";
const AREA_STATE_MODAL_MODE = {
  selectForm: "selectForm",
  currentAreaState: "currentAreaState",
};
class AreaStateListScreen extends Component {
  constructor(props) {
    super(props);
    let { areaId, areaUId, areaName } = this.props.navigation.state.params;
    this.state = {
      areaId,
      areaUId,
      areaName,
      accessToken: "",
      stateIdToChange: undefined,
      stateUIdToChange: undefined,
      stateNameToChange: undefined,
      stateActionToChange: undefined,
      isShowingStateConfirm: false,
      // === save current area state ===
      showFormModal: false,
      addNewAreaStateModalMode: AREA_STATE_MODAL_MODE.selectForm,
      currentDevicesType: [DeviceTypes.LIGHT],
    };
  }
  async componentDidMount() {
    try {
      var { currentServer } = this.props.appReducer;
      this.setState({ accessToken: currentServer.accessToken });
    } catch (e) {
      console.log(e);
    }
  }
  static navigationOptions = ({ screenProps: { translate } }) => ({
    headerTitle: translate("navigation.AreaStates"),
  });
  getItems = () => {
    var items = [];
    //console.log(`this.state.areaId`, this.props.AreaReducer.areas.filter(a => a.areaId == this.state.areaId)[0])
    if (this.state.areaId || this.state.areaUId) {
      for (var i in this.props.AreaReducer.areas) {
        const _area = this.props.AreaReducer.areas[i];
        if (
          _area?.areaId == this.state.areaId ||
          _area.areaUId == this.state.areaUId
        ) {
          items = _area.userDefinedStates || [];
          break;
        }
      }
    }
    return items;
  };

  showChangeStateConfirm(stateId, stateUId, stateName, action) {
    this.setState({
      stateIdToChange: stateId,
      stateUIdToChange: stateUId,
      stateNameToChange: stateName,
      stateActionToChange: action,
      isShowingStateConfirm: true,
    });
  }

  hideChangeStateConfirm() {
    this.setState({
      stateIdToChange: undefined,
      stateUIdToChange: undefined,
      stateNameToChange: undefined,
      stateActionToChange: undefined,
      isShowingStateConfirm: false,
    });
  }
  // === current area State ===
  showCurrentAreaStateModal = () => {
    this.setState({
      showFormModal: true,
      addNewAreaStateModalMode: AREA_STATE_MODAL_MODE.selectForm,
    });
  };
  hideCurrentAreaStateModal = () => {
    this.setState({
      showFormModal: false,
      addNewAreaStateModalMode: AREA_STATE_MODAL_MODE.selectForm,
    });
  };
  navigateToAreaStateForm = (
    navigateProps = {
      areaId: this.state.areaId,
      areaUId: this.state.areaUId,
      areaName: this.state.areaName,
      id: 0, // as new
      uId: "",
    }
  ) => {
    this.hideCurrentAreaStateModal();
    this.props.navigation.navigate("AreaStateForm", navigateProps);
  };
  renderDescriptionText = (label = "", description = "") => {
    return (
      <Text style={{ fontSize: 12, textAlign: "justify", marginBottom: 10 }}>
        <Text style={{ fontSize: 14, fontWeight: "bold" }}>
          {label + " : "}
        </Text>
        {description}
      </Text>
    );
  };
  renderSwitchCustomAreaState = (deviceTypes = DeviceTypes.LIGHT) => {
    return (
      <HStack space="2" alignItems="center" w="50%" mb="5">
        <Switch
          isOn={this.state.currentDevicesType.some(
            (item) => item === deviceTypes
          )}
          size="small"
          onColor={ArTheme.COLORS.ACTIVE}
          offColor={ArTheme.COLORS.MUTED}
          onToggle={(value) => {
            let currentDevicesType = this.state.currentDevicesType;
            if (value) {
              currentDevicesType.push(deviceTypes);
            } else {
              if (currentDevicesType.length !== 1) {
                currentDevicesType = currentDevicesType.filter(
                  (item) => item !== deviceTypes
                );
              }
            }
            this.setState({ currentDevicesType });
          }}
        />
        <Text style={styles.switchText}>
          {translate(`deviceGroup.${deviceTypes}`)}
        </Text>
      </HStack>
    );
  };
  renderAddNewAreaStateModal = () => {
    switch (this.state.addNewAreaStateModalMode) {
      case AREA_STATE_MODAL_MODE.selectForm:
        return (
          <View style={styles.modalContainer}>
            {this.renderDescriptionText(
              translate("areaState.areaFormModal.currentAreaState"),
              translate("areaState.areaFormModal.currentAreaStateDescription")
            )}
            {this.renderDescriptionText(
              translate("areaState.areaFormModal.customization"),
              translate("areaState.areaFormModal.customizationDescription")
            )}
            <HStack space={2}>
              <ArButton
                color="primary"
                onPress={() => {
                  this.setState({
                    addNewAreaStateModalMode:
                      AREA_STATE_MODAL_MODE.currentAreaState,
                  });
                }}
                style={styles.btns}
              >
                {translate("areaState.areaFormModal.currentAreaState")}
              </ArButton>
              <ArButton
                color="muted"
                variant="outline"
                onPress={() => this.navigateToAreaStateForm()}
                style={styles.btns}
              >
                {translate("areaState.areaFormModal.customization")}
              </ArButton>
            </HStack>
          </View>
        );

      case AREA_STATE_MODAL_MODE.currentAreaState:
        return (
          <View style={styles.modalContainer}>
            <HStack>
              {this.renderSwitchCustomAreaState(DeviceTypes.LIGHT)}
              {this.renderSwitchCustomAreaState(DeviceTypes.CURTAIN)}
            </HStack>
            <HStack mb="3">
              {this.renderSwitchCustomAreaState(DeviceTypes.OUTLET)}
              {this.renderSwitchCustomAreaState(DeviceTypes.POWER_SWITCH)}
            </HStack>

            <ArButton
              color="primary"
              onPress={() => {
                this.navigateToAreaStateForm({
                  areaId: this.state.areaId,
                  areaUId: this.state.areaUId,
                  areaName: this.state.areaName,
                  id: 0, // as new
                  uId: "",
                  currentDevicesType: this.state.currentDevicesType, // new current areaState
                });
              }}
              style={styles.btns}
            >
              {translate("app.nextStep")}
            </ArButton>
          </View>
        );
      default:
        break;
    }
  };

  render() {
    var items = this.getItems();

    return (
      <View style={styles.wrapper}>
        {/**title */}
        {this.state.areaName != undefined && (
          <Text style={styles.areaName}>{this.state.areaName}</Text>
        )}
        {/**list */}
        <ScrollView style={styles.wrapper}>
          {/**no item message */}
          {items.length == 0 && (
            <Text style={styles.noItemMessage}>
              {translate("areaState.noItem")}
            </Text>
          )}
          {items.length > 0 &&
            items.map((s, i) => (
              <AreaStateListItem
                key={i}
                id={s.id}
                name={s.name}
                isLoading={s.isLoading || false}
                isActivated={s.isActivated || false}
                activateIcon={s.activeIcon}
                deactivateIcon={s.deActiveIcon}
                onIconPress={() => {
                  var shouldConfirm = false;
                  if (
                    Array.isArray(s.devicesStatus) &&
                    s.devicesStatus.some(
                      (dvc) => dvc.manager == "DoorLockManager"
                    )
                  ) {
                    shouldConfirm = true;
                  } else if (
                    Array.isArray(s.scenariosToRun) &&
                    s.scenariosToRun.length > 0
                  ) {
                    for (var sn in s.scenariosToRun) {
                      let scnId = s.scenariosToRun[sn].scenarioId;
                      let scnUId = s.scenariosToRun[sn].scenarioUId;
                      var scn = this.props.ScenarioReducer.scenarios.find(
                        (sc) => sc.id == scnId || (sc.uId && sc.uId == scnUId)
                      );
                      if (
                        scn &&
                        Array.isArray(scn.actions) &&
                        scn.actions.some(
                          (sa) =>
                            sa.manager == "DoorLockManager" &&
                            (sa.action == "Open" || sa.action == "OpenAll")
                        )
                      ) {
                        shouldConfirm = true;
                      }
                    }
                  }
                  shouldConfirm =
                    shouldConfirm || // either door action is available
                    s.shouldConfirm; //  or forced by object definition
                  if (s.isActivated) {
                    if (shouldConfirm) {
                      this.showChangeStateConfirm(
                        s.id,
                        s.uId,
                        s.name,
                        "deActivate"
                      );
                    } else {
                      this.props.deActivateState(
                        s.id,
                        s.uId,
                        this.state.accessToken
                      );
                    }
                  } else {
                    if (shouldConfirm) {
                      this.showChangeStateConfirm(
                        s.id,
                        s.uId,
                        s.name,
                        "deActivate"
                      );
                    } else {
                      this.props.activateState(
                        s.id,
                        s.uId,
                        this.state.accessToken
                      );
                    }
                  }
                }}
                onTextPress={() => {}}
                onEditPress={() => {
                  this.props.navigation.navigate("AreaStateForm", {
                    areaId: this.state.areaId,
                    areaUId: this.state.areaUId,
                    areaName: this.state.areaName,
                    id: s.id,
                    uId: s.uId,
                  });
                }}
              />
            ))}
        </ScrollView>
        {/**add button */}
        <View style={styles.btnAddHolder}>
          <TouchableHighlight
            underlayColor={ArTheme.COLORS.DARK}
            style={styles.btnAdd}
            onPress={this.showCurrentAreaStateModal}
          >
            <FontAwesomeIcon icon={faPlus} size={30} color="#FFF" />
          </TouchableHighlight>
        </View>
        {/* === current area State Modal === */}
        {this.state.showFormModal && (
          <ModalBase
            header={translate("areaState.areaFormModal.modalHeader")}
            isOpen={true}
            onClose={this.hideCurrentAreaStateModal}
          >
            {this.renderAddNewAreaStateModal()}
          </ModalBase>
        )}
        {/* change state confirm */}
        {this.state.isShowingStateConfirm && (
          <AlertDialogBase
            isOpen={true}
            confirmText={translate("app.confirm")}
            colorConfirm="primary"
            title={translate("v2Dashboard.changeUserDefinedState")}
            confirmHandler={() => {
              if (this.state.stateActionToChange == "activate") {
                this.props.activateState(
                  this.state.stateIdToChange,
                  this.state.stateUIdToChange,
                  this.state.accessToken
                );
              } else if (this.state.stateActionToChange == "deActivate") {
                this.props.deActivateState(
                  this.state.stateIdToChange,
                  this.state.stateUIdToChange,
                  this.state.accessToken
                );
              }
              this.hideChangeStateConfirm();
            }}
            onClose={() => this.hideChangeStateConfirm()}
          >
            <Text>
              {translate("areaState.areaStateChangeMessage", {
                stateName: this.state.stateNameToChange,
                action:
                  this.state.stateActionToChange == "activate"
                    ? translate("areaState.active")
                    : translate("areaState.deActive"),
              })}
            </Text>
          </AlertDialogBase>
        )}
      </View>
    );
  }
}

/**@augments{Component<Props,state>} */
class AreaStateListItem extends Component {
  static propTypes = {
    id: PropTypes.number.isRequired,
    name: PropTypes.string.isRequired,
    isActivated: PropTypes.bool,
    isLoading: PropTypes.bool,
    activateIcon: PropTypes.string,
    deactivateIcon: PropTypes.string,
    onIconPress: PropTypes.func,
    onEditPress: PropTypes.func,
    onTextPress: PropTypes.func,
  };
  constructor() {
    super();
  }
  handleOnIconPress = () => {
    typeof this.props.onIconPress === "function" && this.props.onIconPress();
  };

  handleOnTextPress = () => {
    typeof this.props.onTextPress === "function" && this.props.onTextPress();
  };

  handleOnEditPress = () => {
    typeof this.props.onEditPress === "function" && this.props.onEditPress();
  };

  render() {
    var _icon = this.props.deactivateIcon || faPowerOff;
    var _iconColor = ArTheme.COLORS.MUTED;
    var _fontFamily = FONT_FAMILIES.PRO_LIGHT;
    var _iconSize = 26;

    if (this.props.isActivated) {
      _icon = this.props.activateIcon || faPowerOff;
      _iconColor = ArTheme.COLORS.PRIMARY;
      _fontFamily = FONT_FAMILIES.PRO_REGULAR;
      _iconSize = 32;
    }
    return (
      <View style={styles.listItem}>
        <View
          style={{
            flex: 1,
            flexDirection: "row",
            alignItems: "center",
            height: 55,
          }}
        >
          <TouchableOpacity
            style={[
              styles.listItemIcon,
              Platform.OS == "web"
                ? { borderStartWidth: 1, paddingStart: 10, marginStart: 6 }
                : { borderEndWidth: 1, paddingEnd: 10, marginEnd: 6 },
            ]}
            onPress={this.handleOnIconPress}
          >
            {this.props.isLoading ? (
              <Spinner size={_iconSize} style={{ top: 0, marginBottom: 6 }} />
            ) : (
              <SimpleIcon
                icon={_icon}
                size={_iconSize}
                color={_iconColor}
                fontFamily={_fontFamily}
              />
            )}
          </TouchableOpacity>

          <Text onPress={this.handleOnTextPress} style={styles.listItemText}>
            {this.props.name}
          </Text>
        </View>
        <TouchableOpacity onPress={this.handleOnEditPress}>
          <SimpleIcon icon={faEdit} size={22} />
        </TouchableOpacity>
      </View>
    );
  }
}

function mapStateToProps(state) {
  return {
    AreaReducer: state.AreaReducer,
    ScenarioReducer: state.ScenarioReducer,
    appReducer: state.AppReducer,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    activateState: (stateId, stateUId, accessToken) =>
      dispatch(AreaActions.ActivateState(stateId, stateUId, accessToken)),
    deActivateState: (stateId, stateUId, accessToken) =>
      dispatch(AreaActions.DeActivateState(stateId, stateUId, accessToken)),
  };
}

const styles = StyleSheet.create({
  wrapper: { flex: 1, padding: 10 },
  areaName: {
    fontWeight: "bold",
    fontSize: 24,
    marginTop: 10,
    marginBottom: 15,
  },
  noItemMessage: {
    textAlign: "center",
    color: ArTheme.COLORS.MUTED,
    marginTop: 30,
    fontSize: 14,
  },
  btnAddHolder: {
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "center",
  },
  btnAdd: {
    width: 60,
    height: 60,
    borderRadius: 30,
    backgroundColor: ArTheme.COLORS.PRIMARY,
    marginHorizontal: 15,
    bottom: 15,
    shadowColor: "#000",
    shadowRadius: 5,
    elevation: 10,
    alignSelf: "center",
    alignItems: "center",
    justifyContent: "center",
  },
  listItem: {
    flexDirection: "row",
    backgroundColor: "#FFF",
    borderColor: ArTheme.COLORS.BORDER_COLOR,
    borderWidth: 1,
    borderRadius: 5,
    height: 54,
    padding: 10,
    //marginHorizontal : 3,
    marginVertical: 6,
    alignItems: "center",
    justifyContent: "space-between",
  },
  listItemText: {
    fontSize: 16,
    // height: 54,
    textAlignVertical: "center",
    paddingHorizontal: 10,
  },
  listItemIcon: {
    borderColor: ArTheme.COLORS.BORDER_COLOR,
    width: 42,
    alignItems: "center",
    justifyContent: "center",
  },
  // === Form Mode ===
  modalContainer: {
    padding: 10,
  },
  btns: {
    flex: 1,
    marginBottom: 0,
  },
  switchText: {},
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(AreaStateListScreen);
